// Single source of truth for the rate fields produced by price(). These are the fields copied onto
// order clones (attempt-billing + service split) and persisted back after a reprice. Keeping one
// list avoids drift where a new rate field gets added to some copies but not others.
export const PRICED_RATE_FIELDS = [
    'shipper_rate',
    'carrier_rate',
    'order_revenue',
    'price_breakdown',
    'shipper_rate_override_id',
    'carrier_rate_override_id',
    'middle_mile_shipper_rate',
    'middle_mile_shipper_rate_override_id',
    'middle_mile_carrier_rate',
    'middle_mile_carrier_rate_override_id',
    'pricing_options',
    'middle_mile_pricing_options',
];
